var Globalize = require('globalize');

const getLangMapping = () => {
  var lang = document.getElementsByTagName('html')[0].getAttribute('lang');
  switch (lang.toLowerCase()) {
    case 'it':
    case 'it-it':
      return 'it';
    case 'fr':
    case 'fr-fr':
      return 'fr';
    case 'es':
    case 'es-es':
      return 'es';
    case 'de':
    case 'de-de':
      return 'de';
    case 'en-gb':
      return 'en-GB';
    case 'ko':
    case 'ko-kr':
      return 'ko';
    default:
      return 'en';
  }
};

const init = () => {
  var langMapped = getLangMapping();
  if (langMapped === 'it') {
    Globalize.load(
      require('cldr-data/main/it/ca-gregorian'),
      //   require("cldr-data/main/it/currencies"),
      require('cldr-data/main/it/dateFields'),
      require('cldr-data/main/it/numbers'),
      require('cldr-data/main/it/timeZoneNames'),
      require('cldr-data/main/it/units'),
    );
  } else if (langMapped === 'fr') {
    Globalize.load(
      require('cldr-data/main/fr/ca-gregorian'),
      //   require("cldr-data/main/fr/currencies"),
      require('cldr-data/main/fr/dateFields'),
      require('cldr-data/main/fr/numbers'),
      require('cldr-data/main/fr/timeZoneNames'),
      require('cldr-data/main/fr/units'),
    );
  } else if (langMapped === 'es') {
    Globalize.load(
      require('cldr-data/main/es/ca-gregorian'),
      //   require("cldr-data/main/es/currencies"),
      require('cldr-data/main/es/dateFields'),
      require('cldr-data/main/es/numbers'),
      require('cldr-data/main/es/timeZoneNames'),
      require('cldr-data/main/es/units'),
    );
  } else if (langMapped === 'de') {
    Globalize.load(
      require('cldr-data/main/de/ca-gregorian'),
      //   require("cldr-data/main/de/currencies"),
      require('cldr-data/main/de/dateFields'),
      require('cldr-data/main/de/numbers'),
      require('cldr-data/main/de/timeZoneNames'),
      require('cldr-data/main/de/units'),
    );
  } else if (langMapped === 'en-GB') {
    Globalize.load(
      require('cldr-data/main/en-GB/ca-gregorian'),
      //   require("cldr-data/main/en-GB/currencies"),
      require('cldr-data/main/en-GB/dateFields'),
      require('cldr-data/main/en-GB/numbers'),
      require('cldr-data/main/en-GB/timeZoneNames'),
      require('cldr-data/main/en-GB/units'),
    );
  } else if (langMapped === 'ko') {
    Globalize.load(
      require('cldr-data/main/ko/ca-gregorian'),
      //   require("cldr-data/main/ko/currencies"),
      require('cldr-data/main/ko/dateFields'),
      require('cldr-data/main/ko/numbers'),
      require('cldr-data/main/ko/timeZoneNames'),
      require('cldr-data/main/ko/units'),
    );
  } else {
    Globalize.load(
      require('cldr-data/main/en/ca-gregorian'),
      //   require("cldr-data/main/en/currencies"),
      require('cldr-data/main/en/dateFields'),
      require('cldr-data/main/en/numbers'),
      require('cldr-data/main/en/timeZoneNames'),
      require('cldr-data/main/en/units'),
    );
  }

  Globalize.load(
    //   require("cldr-data/supplemental/currencyData"),
    require('cldr-data/supplemental/likelySubtags'),
    require('cldr-data/supplemental/metaZones'),
    // require("cldr-data/supplemental/plurals"),
    require('cldr-data/supplemental/timeData'),
    require('cldr-data/supplemental/weekData'),
  );

  Globalize.locale(langMapped);
};

const parseDate = (value) => {
  return Globalize.parseDate(value, { skeleton: 'yMd' });
};

const formatDateShort = (date) => {
  return Globalize.formatDate(new Date(date), { date: 'short' });
};

const formatDateLong = (date) => {
  return Globalize.formatDate(new Date(date), { date: 'long' });
};

const formatDateFull = (date) => {
  // "The fields are from the Date Field Symbol Table in Date Format Patterns"
  // Ref: http://www.unicode.org/reports/tr35/tr35-dates.html#availableFormats_appendItems
  // I.e., check for invalid characters.
  // /[^GyYuUrQqMLlwWEecdDFghHKkmsSAzZOvVXx]/
  return Globalize.formatDate(new Date(date), {
    skeleton: 'MMMMEEEEd',
  });
};

const formatTime = (time) => {
  // data a caso per far sì che Globalizer restituisca l'orario
  const d = new Date(`January 1, 2000 ${time}`);
  return Globalize.formatDate(d, { skeleton: 'jm' });
};

const numberFormatterPercent = (
  number,
  maximumFractionDigits = 0,
  round = 'floor',
) => {
  return Globalize.numberFormatter({
    style: 'percent',
    round: round,
    maximumFractionDigits: maximumFractionDigits,
  })(number / 100);
};

const formatNumber = (number, fractionDigits = 2) => {
  return Globalize.formatNumber(number, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
};

const formatDistance = (number, minDigits = 1, maxDigits = 3) => {
  return Globalize.formatNumber(number, {
    minimumFractionDigits: minDigits,
    maximumFractionDigits: maxDigits,
  });
};

var Globalizer = {
  getLangMapping,
  init,
  parseDate,
  formatDateShort,
  formatDateLong,
  formatDateFull,
  formatTime,
  numberFormatterPercent,
  formatNumber,
  formatDistance,
};

export default Globalizer;
